var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25054 12.639C7.25278 12.2595 7.33513 11.8848 7.49221 11.5394C7.65688 11.1658 7.9256 10.8475 8.26629 10.6225C8.60697 10.3975 9.00522 10.2754 9.41346 10.2706H19.5876C19.9959 10.2754 20.3941 10.3975 20.7348 10.6225C21.0755 10.8475 21.3442 11.1658 21.5089 11.5394C21.7119 11.9692 21.7901 12.4475 21.7346 12.9196C21.679 13.3918 21.492 13.8388 21.1947 14.2098L16.1076 20.3723C15.9152 20.614 15.6708 20.8091 15.3926 20.9433C15.1143 21.0774 14.8094 21.1471 14.5005 21.1471C14.1917 21.1471 13.8867 21.0774 13.6085 20.9433C13.3303 20.8091 13.0858 20.614 12.8935 20.3723L7.80637 14.2098C7.44614 13.7656 7.24986 13.2109 7.25054 12.639Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.10eb2135259db4da5be2ec44454282bb.svg";
export { ForwardRef as ReactComponent };